import {
  MinGPCommitmentEnum,
  CoInvestPolicyEnum,
} from '../../enums/closedEnd.enum';
import { IClosedEndStructure } from '../../interfaces/investment-vehicle/closed-end-structure.interface';

export class ClosedEndStructure implements IClosedEndStructure {
  closedEndDataFieldsId: number | undefined = undefined;
  minGPCommitmentType: MinGPCommitmentEnum | undefined = undefined;
  minGPCommitment: number | undefined = undefined;
  minGPCommitmentAmount: number | undefined = undefined;
  minGPCommitmentCashless: boolean | undefined = undefined;
  coInvestPolicy: CoInvestPolicyEnum | undefined = undefined;
}
